import clsx from 'clsx'
import CaretLeft from '../icons/Arrows/CaretLeft'
import CaretRight from '../icons/Arrows/CaretRight'
import EllipseIcon from '../icons/Interface/EllipseIcon'
import { TypographyLabel } from '../typography'

const Pagination = ({
	count,
	index,
	pageSize = 10,
	setIndex,
}: {
	count: number
	index: number
	pageSize?: number
	setIndex: (index: number) => void
}) => {
	const handlePrevious = () => setIndex((index - 1 + count) % count)
	const handleNext = () => setIndex((index + 1) % count)

	return (
		<div className="flex h-full w-full flex-row items-center justify-center gap-x-4">
			{index > 0 && (
				<div
					className="cursor-pointer text-textPrimaryLight hover:text-textPrimaryLight dark:text-textPrimaryDark dark:hover:text-textPrimaryDark"
					onClick={handlePrevious}
				>
					<CaretLeft />
				</div>
			)}
			{Array.from({ length: Math.ceil(count / pageSize) }).map((_, i) => (
				<div
					className={clsx(
						index === i
							? 'bg-textPrimaryLight text-textPrimaryDark dark:bg-textPrimaryDark dark:text-textPrimaryLight'
							: ' cursor-pointer text-textSecondaryLight hover:bg-uiSecondaryLight hover:text-textPrimaryLight dark:text-textSecondaryDark dark:hover:bg-uiPrimaryDark dark:hover:text-textPrimaryDark',
						'flex h-[27px] w-[27px] flex-row items-center justify-center rounded-md transition-colors duration-500 ease-in-out',
					)}
					key={i}
					onClick={() => setIndex(i)}
				>
					<TypographyLabel size="medium">{i + 1}</TypographyLabel>
				</div>
			))}
			{index < count && (
				<div
					className={
						index + 1 === count
							? 'cursor-not-allowed text-textInactiveLight dark:text-textInactiveDark'
							: 'cursor-pointer text-textPrimaryLight hover:text-textPrimaryLight dark:text-textPrimaryDark dark:hover:text-textPrimaryDark'
					}
					onClick={handleNext}
				>
					<CaretRight />
				</div>
			)}
		</div>
	)
}

export default Pagination
